<template>
  <div class="anonymous-call">
    <div class="main">
      <initiateCallVue
        @onInitiateCall="initiateCall"
        @onAddTimes="addTimes"
        v-if="AnonymousCallProvider.state === 0"
      />
      <beingMatchedVue
        @onCancel="cancel()"
        @refresh="getDetail(AnonymousCallProvider.roomUid)"
        v-if="AnonymousCallProvider.state === 1"
      ></beingMatchedVue>
      <onPhoneVue
        v-if="AnonymousCallProvider.state === 2"
        @publish="publish"
        @continuous="handleContinuous()"
      ></onPhoneVue>
      <phoneEndingVue
        v-if="AnonymousCallProvider.state === 3"
        @retry="initiateCall()"
      ></phoneEndingVue>
      <notConnectedVue
        v-if="AnonymousCallProvider.state === 4"
        @onBack="changeState(0)"
      ></notConnectedVue>
    </div>
  </div>
</template>
<script>
import initiateCallVue from './initiate-call.vue';
import beingMatchedVue from './being-matched.vue';
import onPhoneVue from './on-phone.vue';
import AnonymousCallProvider from './anonymousCall';
import phoneEndingVue from './phone-ending';
import notConnectedVue from './not-connected';
import {
  checkOrder as checkOrderRequest,
  getDetail as getDetailRequest,
  getCount as getCountRequest,
  createAnonymousCall as createAnonymousCallRequest,
  publishData,
  continuous,
  leaveRoom as leaveRoomRequest,
  plusCount
} from './api';
import { mapGetters } from 'vuex';

export default {
  name: 'AnonymousCallMain',
  components: {
    initiateCallVue,
    beingMatchedVue,
    onPhoneVue,
    phoneEndingVue,
    notConnectedVue
  },
  props: {},
  data() {
    return {
      AnonymousCallProvider,
      timer: null,
      currentTime: new Date(),
      openTimer: null
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['accountInfo']),
    balance() {
      return this.accountInfo ? this.accountInfo.balance || 0 : 0;
    },
    isNotEnoughBalance() {
      return this.balance < 100;
    },
    isOpen() {
      const hours = this.currentTime.getHours();
      return hours >= 20 || hours < 2;
    }
  },
  methods: {
    async addTimes() {
      if (this.AnonymousCallProvider.allowPlusTimes) {
        await plusCount();
        this.getCount();
      } else {
        this.$confirm({
          content: '今日購買匿名來電次數已用完',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: true
        }).then(() => {});
      }
    },
    initiateCall() {
      if (this.AnonymousCallProvider.times < 1) {
        this.$confirm({
          content: '今日發起匿名來電次數已用完',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          this.AnonymousCallProvider.setState(0);
        });
        return;
      }
      this.createAnonymousCall();
    },
    async handleContinuous() {
      try {
        await continuous({
          roomUid: this.AnonymousCallProvider.roomUid
        });
        this.$message.success('成功續時10分鐘');
        this.getDetail(this.AnonymousCallProvider.roomUid);
      } catch (error) {
        this.$message.success('續時失败');
      }
    },
    async publish(user) {
      await publishData({
        roomUid: this.AnonymousCallProvider.roomUid,
        userUuid: user.userUuid,
        type: user.type
      });
      this.getDetail(this.AnonymousCallProvider.roomUid);
    },
    async createAnonymousCall() {
      const genderRule =
        AnonymousCallProvider.matchGender === 'random'
          ? 0
          : AnonymousCallProvider.matchGender === 'male'
          ? 1
          : 2;
      this.changeState(1);
      const { data } = await createAnonymousCallRequest({
        genderRule: genderRule
      });
      const { status, roomUid } = data;
      if (status === 0) {
        AnonymousCallProvider.setRoomUid(roomUid);
        this.checkOrder();
      } else if (status === 1) {
        this.checkOrder();
      } else {
        this.$message.error('發起匿名通話失敗');
      }
    },
    async changeState(state) {
      if (state === 0) {
        await this.getCount();
      }
      this.AnonymousCallProvider.setState(state);
    },
    async cancel() {
      await leaveRoomRequest({
        roomUid: this.AnonymousCallProvider.roomUid
      });
      this.changeState(0);
    },
    async checkOrder() {
      const { data } = await checkOrderRequest();
      const roomUid = data.roomUid || this.$route.params.roomUid;
      if (roomUid) {
        this.AnonymousCallProvider.setRoomUid(roomUid);
        this.getDetail(roomUid);
        localStorage.setItem('voiceRoomId', this.AnonymousCallProvider.roomUid);
      } else {
        this.changeState(0);
      }
    },
    async getDetail(roomUid) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const { data } = await getDetailRequest({ roomUid });
      const { open, users } = data;
      this.loading = false;
      if (!open) {
        if (users) {
          if (users.length === 1) {
            this.changeState(4);
          }
          if (users.length === 2) {
            this.changeState(3);
          }
          return;
        } else {
          if (this.AnonymousCallProvider.state == 1) {
            this.changeState(4);
          } else if (this.AnonymousCallProvider.state == 2) {
            this.changeState(3);
          } else if (this.AnonymousCallProvider.state == 3) {
            this.changeState(3);
          } else if (this.AnonymousCallProvider.state == 4) {
            this.changeState(4);
          } else {
            this.changeState(0);
          }
        }
      }
      this.AnonymousCallProvider.initData(data);
      if (users) {
        if (users.length === 1) {
          this.changeState(1);
        }
        if (users.length === 2) {
          this.changeState(2);
        }
      }
    },
    async getCount() {
      try {
        const { data } = await getCountRequest();
        this.AnonymousCallProvider.setTimes(data);
      } catch (error) {
        const message =
          error && error.msg ? error.msg : '獲得3次發起失败，一日只能續加一次';
        this.$message.error(message);
      }
    },
    async dynamic() {
      this.timer = setInterval(() => {
        if (this.AnonymousCallProvider.roomUid) {
          this.getDetail(this.AnonymousCallProvider.roomUid);
        }
      }, 3000);
    },
    async leaveRoom() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    setAnonymousCalling() {
      localStorage.setItem('anonymousCalling', Math.random());
    },
    async init() {
      try {
        this.getCount();
        this.checkOrder();
        this.dynamic();
        localStorage.setItem('voiceRoomId', '');
        this.localVoiceRoomId = this.AnonymousCallProvider.roomUid;
        // 在一个标签页中
        window.onstorage = e => {
          if (e.key === 'voiceRoomId' && e.newValue !== this.localVoiceRoomId) {
            this.$router.replace('/');
          }
          if (e.key === 'checkAnonymousCalling') {
            if (
              this.AnonymousCallProvider.state === 2 ||
              this.AnonymousCallProvider.state === 1
            ) {
              console.log(
                'checkAnonymousCalling',
                this.AnonymousCallProvider.state
              );
              this.setAnonymousCalling();
            } else {
              localStorage.setItem('anonymousCalling', '');
            }
          }
        };
      } catch (error) {
        console.log(error);
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.checkOrder();
    next();
  },
  created() {
    this.AnonymousCallProvider.setState(null);
    this.openTimer = setInterval(() => {
      this.currentTime = new Date();
    }, 60000);
    if (this.isOpen) {
      this.init();
    } else {
      this.$confirm({
        content: '此功能暫只在18-24時開放',
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickModal: true
      }).then(() => {
        this.$router.push({ path: '/' });
      });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.openTimer) {
      clearInterval(this.openTimer);
    }
    this.leaveRoom();
  }
};
</script>
<style lang="scss" scoped>
.anonymous-call {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-image: url('./images/web-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  display: flex;
  flex-direction: column;
  width: 450px;
  height: 100%;
}
</style>
